import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/Dashboard';
import Customers from './components/Customers';
import Orders from './components/Orders';
import CustomerAdd from './components/CustomerAdd';
import CustomerUpdate from './components/CustomerUpdate';
import SalesReps from './components/SalesReps';
import SalesRepAdd from './components/SalesRepAdd';
import OrderCreate from './components/OrderCreate';
import OrderUpdate from './components/OrderUpdate';
import OrderReOrder from './components/OrderReOrder';
import OrderView from './components/OrderView';
import CustomerOrdres from './components/OrdersCustomer';
import ProfileUpdate from './components/Profile';
import ExportData from './components/ExportCsv';
import AddFabricForm from './components/FabricAdd';
import Settings from './components/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />}>
          <Route path="sales-reps" element={<SalesReps />} />
          <Route path="sales-reps/add" element={<SalesRepAdd />} />
          <Route path="customers" element={<Customers />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/create" element={<OrderCreate />} />
          <Route path="orders/reorder/:id" element={<OrderReOrder />} />
          <Route path="orders/view/:id" element={<OrderView />} />
          <Route path="orders/:id" element={<OrderUpdate />} />
          <Route path="customers/add" element={<CustomerAdd />} />
          <Route path="customers/:id" element={<CustomerUpdate />} />
          <Route path="customers/orders/:id" element={<CustomerOrdres />} />
          <Route path="profile" element={<ProfileUpdate />} />
          <Route path="exportcsv" element={<ExportData />} />
          <Route path="addFabric" element={<AddFabricForm />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
